// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueCookie from 'vue-cookie'
import ElementUI from 'element-ui'
import interceptors from 'common/ajax/interceptors'

import 'common/stylus/index.styl'
import 'element-ui/lib/theme-chalk/index.css'
import 'common/stylus/common.styl'

Vue.config.productionTip = false

interceptors()

Vue.use(VueCookie)
Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>',
  data: {
    eventBus: new Vue()
  }
})



// WEBPACK FOOTER //
// ./src/main.js